import { QUERY_KEY } from '@/constants/queryKey'
import { useQuery } from 'react-query'
import { fetchMerchantPolicies } from '@/api/livemallclub/fetchMerchantPolicies'
import { isLiveMallClub } from '@/constants/systemType'

const useMerchantPolicies = ({ merchantId }: { merchantId: string }) => {
  const { data, ...query } = useQuery({
    queryKey: [QUERY_KEY.FETCH_MERCHANT_POLICIES, merchantId],
    queryFn: () => fetchMerchantPolicies({ merchantId: Number(merchantId) }),
    enabled: isLiveMallClub && !!merchantId,
  })
  return { data, query }
}

export default useMerchantPolicies
